module.exports = __webpack_public_path__ + "img/dreamweavers-4.f7dfe9db.webp";